"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.justifyContentEnum = exports.gridDirection = exports.alignItemsEnum = void 0;
let gridDirection = exports.gridDirection = /*#__PURE__*/function (gridDirection) {
  gridDirection["row"] = "row";
  gridDirection["column"] = "column";
  gridDirection["rowReverse"] = "row-reverse";
  gridDirection["columnReverse"] = "column-reverse";
  return gridDirection;
}({});
let alignItemsEnum = exports.alignItemsEnum = /*#__PURE__*/function (alignItemsEnum) {
  alignItemsEnum["baseLine"] = "baseline";
  alignItemsEnum["center"] = "center";
  alignItemsEnum["end"] = "end";
  alignItemsEnum["flexEnd"] = "flex-end";
  alignItemsEnum["flexStart"] = "flex-start";
  alignItemsEnum["initial"] = "initial";
  alignItemsEnum["inherit"] = "inherit";
  alignItemsEnum["normal"] = "normal";
  alignItemsEnum["revert"] = "revert";
  alignItemsEnum["selfStart"] = "self-start";
  alignItemsEnum["selfEnd"] = "self-end";
  alignItemsEnum["start"] = "start";
  alignItemsEnum["stretch"] = "stretch";
  alignItemsEnum["unset"] = "unset";
  return alignItemsEnum;
}({});
let justifyContentEnum = exports.justifyContentEnum = /*#__PURE__*/function (justifyContentEnum) {
  justifyContentEnum["start"] = "start";
  justifyContentEnum["end"] = "end";
  justifyContentEnum["center"] = "center";
  justifyContentEnum["left"] = "left";
  justifyContentEnum["right"] = "right";
  justifyContentEnum["flexStart"] = "flex-start";
  justifyContentEnum["flexEnd"] = "flex-end";
  justifyContentEnum["inherit"] = "inherit";
  justifyContentEnum["initial"] = "initial";
  justifyContentEnum["revert"] = "revert";
  justifyContentEnum["stretch"] = "stretch";
  justifyContentEnum["unset"] = "unset";
  justifyContentEnum["normal"] = "normal";
  justifyContentEnum["spaceBetween"] = "space-between";
  justifyContentEnum["spaceEvenly"] = "space-evenly";
  justifyContentEnum["spaceAround"] = "space-around";
  return justifyContentEnum;
}({});